/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Lucio API
 * Lucio AI Outlook Add-in Backend API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorResponse,
  GetUserAssistantPreferences200,
  GetUserInitialSyncStatus200,
  GetUserIntercom200,
  PostUserAssistantPreferences200,
  PostUserAssistantPreferencesBody,
  PostUserGenerateProfile200,
  PostUserGenerateProfileBody,
  PostUserNarrativePreferences200,
  PostUserNarrativePreferencesBody,
  PutUserAssistantPreferencesProfile200,
  PutUserAssistantPreferencesProfileBody,
  PutUserDisplayName200,
  PutUserDisplayNameBody,
  PutUserLocale200,
  PutUserLocaleBody,
  PutUserTimezone200,
  PutUserTimezoneBody,
  ValidationErrorResponse
} from '../lucioAPI.schemas';

import { customInstance } from '../../mutator';




/**
 * Retrieve the current user assistant and narrative preferences.
 * @summary Get assistant preferences
 */
export const getUserAssistantPreferences = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserAssistantPreferences200>(
      {url: `/user/assistant-preferences`, method: 'GET', signal
    },
      );
    }
  



export const getGetUserAssistantPreferencesQueryKey = () => {
    return [
    `/user/assistant-preferences`
    ] as const;
    }

    
export const getGetUserAssistantPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAssistantPreferencesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAssistantPreferences>>> = ({ signal }) => getUserAssistantPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAssistantPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAssistantPreferences>>>
export type GetUserAssistantPreferencesQueryError = ErrorResponse


export function useGetUserAssistantPreferences<TData = Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssistantPreferences>>,
          TError,
          Awaited<ReturnType<typeof getUserAssistantPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssistantPreferences<TData = Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAssistantPreferences>>,
          TError,
          Awaited<ReturnType<typeof getUserAssistantPreferences>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAssistantPreferences<TData = Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get assistant preferences
 */

export function useGetUserAssistantPreferences<TData = Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAssistantPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAssistantPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Enable or disable AI memory for the assistant.
 * @summary Update assistant preferences
 */
export const postUserAssistantPreferences = (
    postUserAssistantPreferencesBody: PostUserAssistantPreferencesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostUserAssistantPreferences200>(
      {url: `/user/assistant-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserAssistantPreferencesBody, signal
    },
      );
    }
  


export const getPostUserAssistantPreferencesMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAssistantPreferences>>, TError,{data: PostUserAssistantPreferencesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserAssistantPreferences>>, TError,{data: PostUserAssistantPreferencesBody}, TContext> => {

const mutationKey = ['postUserAssistantPreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserAssistantPreferences>>, {data: PostUserAssistantPreferencesBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserAssistantPreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserAssistantPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postUserAssistantPreferences>>>
    export type PostUserAssistantPreferencesMutationBody = PostUserAssistantPreferencesBody
    export type PostUserAssistantPreferencesMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update assistant preferences
 */
export const usePostUserAssistantPreferences = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAssistantPreferences>>, TError,{data: PostUserAssistantPreferencesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserAssistantPreferences>>,
        TError,
        {data: PostUserAssistantPreferencesBody},
        TContext
      > => {

      const mutationOptions = getPostUserAssistantPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns whether the initial email embedding generation is completed for the current user.
 * @summary Get initial mailbox sync status
 */
export const getUserInitialSyncStatus = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserInitialSyncStatus200>(
      {url: `/user/initial-sync-status`, method: 'GET', signal
    },
      );
    }
  



export const getGetUserInitialSyncStatusQueryKey = () => {
    return [
    `/user/initial-sync-status`
    ] as const;
    }

    
export const getGetUserInitialSyncStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInitialSyncStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInitialSyncStatus>>> = ({ signal }) => getUserInitialSyncStatus(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserInitialSyncStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInitialSyncStatus>>>
export type GetUserInitialSyncStatusQueryError = ErrorResponse


export function useGetUserInitialSyncStatus<TData = Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInitialSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserInitialSyncStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInitialSyncStatus<TData = Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInitialSyncStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserInitialSyncStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserInitialSyncStatus<TData = Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get initial mailbox sync status
 */

export function useGetUserInitialSyncStatus<TData = Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInitialSyncStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserInitialSyncStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieve an Intercom user JWT for the authenticated user.
 * @summary Get Intercom JWT token
 */
export const getUserIntercom = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetUserIntercom200>(
      {url: `/user/intercom`, method: 'GET', signal
    },
      );
    }
  



export const getGetUserIntercomQueryKey = () => {
    return [
    `/user/intercom`
    ] as const;
    }

    
export const getGetUserIntercomQueryOptions = <TData = Awaited<ReturnType<typeof getUserIntercom>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIntercomQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserIntercom>>> = ({ signal }) => getUserIntercom(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIntercomQueryResult = NonNullable<Awaited<ReturnType<typeof getUserIntercom>>>
export type GetUserIntercomQueryError = ErrorResponse


export function useGetUserIntercom<TData = Awaited<ReturnType<typeof getUserIntercom>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIntercom>>,
          TError,
          Awaited<ReturnType<typeof getUserIntercom>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIntercom<TData = Awaited<ReturnType<typeof getUserIntercom>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserIntercom>>,
          TError,
          Awaited<ReturnType<typeof getUserIntercom>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserIntercom<TData = Awaited<ReturnType<typeof getUserIntercom>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Intercom JWT token
 */

export function useGetUserIntercom<TData = Awaited<ReturnType<typeof getUserIntercom>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserIntercom>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIntercomQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Set narrative writing style or sample narratives for narrative generation.
 * @summary Update narrative preferences
 */
export const postUserNarrativePreferences = (
    postUserNarrativePreferencesBody: PostUserNarrativePreferencesBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostUserNarrativePreferences200>(
      {url: `/user/narrative-preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserNarrativePreferencesBody, signal
    },
      );
    }
  


export const getPostUserNarrativePreferencesMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserNarrativePreferences>>, TError,{data: PostUserNarrativePreferencesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserNarrativePreferences>>, TError,{data: PostUserNarrativePreferencesBody}, TContext> => {

const mutationKey = ['postUserNarrativePreferences'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserNarrativePreferences>>, {data: PostUserNarrativePreferencesBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserNarrativePreferences(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserNarrativePreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postUserNarrativePreferences>>>
    export type PostUserNarrativePreferencesMutationBody = PostUserNarrativePreferencesBody
    export type PostUserNarrativePreferencesMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update narrative preferences
 */
export const usePostUserNarrativePreferences = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserNarrativePreferences>>, TError,{data: PostUserNarrativePreferencesBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserNarrativePreferences>>,
        TError,
        {data: PostUserNarrativePreferencesBody},
        TContext
      > => {

      const mutationOptions = getPostUserNarrativePreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Save or overwrite the user assistant profile (drafting preferences and general info).
 * @summary Save assistant profile
 */
export const putUserAssistantPreferencesProfile = (
    putUserAssistantPreferencesProfileBody: PutUserAssistantPreferencesProfileBody,
 ) => {
      
      
      return customInstance<PutUserAssistantPreferencesProfile200>(
      {url: `/user/assistant-preferences/profile`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserAssistantPreferencesProfileBody
    },
      );
    }
  


export const getPutUserAssistantPreferencesProfileMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>, TError,{data: PutUserAssistantPreferencesProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>, TError,{data: PutUserAssistantPreferencesProfileBody}, TContext> => {

const mutationKey = ['putUserAssistantPreferencesProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>, {data: PutUserAssistantPreferencesProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserAssistantPreferencesProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserAssistantPreferencesProfileMutationResult = NonNullable<Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>>
    export type PutUserAssistantPreferencesProfileMutationBody = PutUserAssistantPreferencesProfileBody
    export type PutUserAssistantPreferencesProfileMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Save assistant profile
 */
export const usePutUserAssistantPreferencesProfile = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>, TError,{data: PutUserAssistantPreferencesProfileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserAssistantPreferencesProfile>>,
        TError,
        {data: PutUserAssistantPreferencesProfileBody},
        TContext
      > => {

      const mutationOptions = getPutUserAssistantPreferencesProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Generate user profile from sent emails using AI agent.
 * @summary Generate user profile
 */
export const postUserGenerateProfile = (
    postUserGenerateProfileBody: PostUserGenerateProfileBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PostUserGenerateProfile200>(
      {url: `/user/generate-profile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserGenerateProfileBody, signal
    },
      );
    }
  


export const getPostUserGenerateProfileMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateProfile>>, TError,{data: PostUserGenerateProfileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateProfile>>, TError,{data: PostUserGenerateProfileBody}, TContext> => {

const mutationKey = ['postUserGenerateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserGenerateProfile>>, {data: PostUserGenerateProfileBody}> = (props) => {
          const {data} = props ?? {};

          return  postUserGenerateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserGenerateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postUserGenerateProfile>>>
    export type PostUserGenerateProfileMutationBody = PostUserGenerateProfileBody
    export type PostUserGenerateProfileMutationError = ErrorResponse

    /**
 * @summary Generate user profile
 */
export const usePostUserGenerateProfile = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGenerateProfile>>, TError,{data: PostUserGenerateProfileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserGenerateProfile>>,
        TError,
        {data: PostUserGenerateProfileBody},
        TContext
      > => {

      const mutationOptions = getPostUserGenerateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update the current user locale (UI language and regional formatting).
 * @summary Update user locale
 */
export const putUserLocale = (
    putUserLocaleBody: PutUserLocaleBody,
 ) => {
      
      
      return customInstance<PutUserLocale200>(
      {url: `/user/locale`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserLocaleBody
    },
      );
    }
  


export const getPutUserLocaleMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserLocale>>, TError,{data: PutUserLocaleBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserLocale>>, TError,{data: PutUserLocaleBody}, TContext> => {

const mutationKey = ['putUserLocale'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserLocale>>, {data: PutUserLocaleBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserLocale(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserLocaleMutationResult = NonNullable<Awaited<ReturnType<typeof putUserLocale>>>
    export type PutUserLocaleMutationBody = PutUserLocaleBody
    export type PutUserLocaleMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update user locale
 */
export const usePutUserLocale = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserLocale>>, TError,{data: PutUserLocaleBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserLocale>>,
        TError,
        {data: PutUserLocaleBody},
        TContext
      > => {

      const mutationOptions = getPutUserLocaleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update the current user's IANA timezone (e.g. Asia/Tokyo). Used to compute user-local narrative day windows and the current-date line in LLM prompts.
 * @summary Update user timezone
 */
export const putUserTimezone = (
    putUserTimezoneBody: PutUserTimezoneBody,
 ) => {
      
      
      return customInstance<PutUserTimezone200>(
      {url: `/user/timezone`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserTimezoneBody
    },
      );
    }
  


export const getPutUserTimezoneMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserTimezone>>, TError,{data: PutUserTimezoneBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserTimezone>>, TError,{data: PutUserTimezoneBody}, TContext> => {

const mutationKey = ['putUserTimezone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserTimezone>>, {data: PutUserTimezoneBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserTimezone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserTimezoneMutationResult = NonNullable<Awaited<ReturnType<typeof putUserTimezone>>>
    export type PutUserTimezoneMutationBody = PutUserTimezoneBody
    export type PutUserTimezoneMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update user timezone
 */
export const usePutUserTimezone = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserTimezone>>, TError,{data: PutUserTimezoneBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserTimezone>>,
        TError,
        {data: PutUserTimezoneBody},
        TContext
      > => {

      const mutationOptions = getPutUserTimezoneMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Update the current user's display name (used in greetings and LLM prompts).
 * @summary Update user display name
 */
export const putUserDisplayName = (
    putUserDisplayNameBody: PutUserDisplayNameBody,
 ) => {
      
      
      return customInstance<PutUserDisplayName200>(
      {url: `/user/display-name`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putUserDisplayNameBody
    },
      );
    }
  


export const getPutUserDisplayNameMutationOptions = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDisplayName>>, TError,{data: PutUserDisplayNameBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserDisplayName>>, TError,{data: PutUserDisplayNameBody}, TContext> => {

const mutationKey = ['putUserDisplayName'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserDisplayName>>, {data: PutUserDisplayNameBody}> = (props) => {
          const {data} = props ?? {};

          return  putUserDisplayName(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserDisplayNameMutationResult = NonNullable<Awaited<ReturnType<typeof putUserDisplayName>>>
    export type PutUserDisplayNameMutationBody = PutUserDisplayNameBody
    export type PutUserDisplayNameMutationError = ValidationErrorResponse | ErrorResponse

    /**
 * @summary Update user display name
 */
export const usePutUserDisplayName = <TError = ValidationErrorResponse | ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserDisplayName>>, TError,{data: PutUserDisplayNameBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserDisplayName>>,
        TError,
        {data: PutUserDisplayNameBody},
        TContext
      > => {

      const mutationOptions = getPutUserDisplayNameMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    